export default "__VITE_ASSET__B3tXyGw1__"